import {doFetch} from "vimmi-web-utils/cjs/doFetch";
import Config from "./config";
import {formatDate} from "vimmi-web-utils/cjs/formatDate";

export class Channels {
  constructor() {
    this.channels = {};
  }

  async getChannels() {
    if (Object.keys(this.channels).length) {
      return this.channels;
    }
    let channels = await doFetch(`/${Config.get('env')}-channels.json`);
    return Promise.all(Object.keys(channels).map((id) => {
      return doFetch(`https://${Config.get('backend')}/get_item/${id}/?d=web`)
    })).then((resp) => {
      resp.map((channel) => {
        this.channels[channel.head.id] = {...channel.head, ...channels[channel.head.id]};
      })
      return this.channels;
    });
  }


  filter(amsChannels, ids) {
    return amsChannels.filter((channel) => {
      return ids.includes(channel.id);
    })
  }
}

const channelsSrv = new Channels();
export default channelsSrv;
